import * as React from "react"
import * as styles from "./events-loading.css"

export function DataLayerEventsLoading() {
  const rows = [...Array(3)].map((_, idx) => idx)
  const columns = [...Array(5)].map((_, idx) => idx)

  return (
    <div className={styles.rows}>
      {rows.map(row => (
        <div key={row} className={styles.row}>
          {columns.map(col => (
            <div key={col} className={styles.column} />
          ))}
        </div>
      ))}
    </div>
  )
}
